/**
 * Please put all assets that need to be loaded here in this file
 * (pretty please, don't put them in main or the scene manager  :-)  )
 *
 * @author Preston Sia, Emma Szebenyi
 */
/** All player related assets */
export const playerAssets = [
    { id: "player", type: "img", location: "./assets/EmployeeFullSpriteSheet.png" }
];
/** All monster assets */
export const monsterAssets = [
    { id: "monster", type: "img", location: "./assets/MonsterSpriteSheet.png" }
];
/** All boss assets */
export const bossAssets = [
    { id: "satisfactionBar", type: "img", location: "./assets/BossSatisfactionBar3.png" },
    { id: "bossIcons", type: "img", location: "./assets/BossSpriteSheet.png" },
];
/** All environment assets, such as shelves, desks, obstacles, background music, and more */
export const environmentAssets = [
    { id: "gameMusic", type: "audio", location: "./assets/gameMusic.ogg" },
    { id: "startupMusic", type: "audio", location: "./assets/startupMusic.ogg" },
    { id: "titleImage", type: "img", location: "./assets/ProjectRunnerTitle.png" },
    //{ id: "tempbg", type: "img", location: "./assets/tempbg.JPG" },
    { id: "titleScreen", type: "img", location: "./assets/title_screen_v2.png" },
    { id: "titleText", type: "img", location: "./assets/project_runner_title.png" },
    { id: "AllHShelves", type: "img", location: "./assets/AllHShelves.png" },
    { id: "arrow", type: "img", location: "./assets/ArrowSpritesheet.png" },
    { id: "floor", type: "img", location: "./assets/StoreFloorTexture.png" },
    { id: "floorGrid", type: "img", location: "./assets/FloorGrid.png" },
    { id: "light", type: "img", location: "./assets/Light.png" },
    { id: "empLight", type: "img", location: "./assets/EmployeeLight.png" },
    //{ id: "empShad", type: "img", location: "./assets/EmployeeShadow.png" },
    { id: "blood", type: "img", location: "./assets/BloodSplatter.png" },
    { id: "shelfShadow", type: "img", location: "./assets/ShelfShadow.png" },
    { id: "parkingLot", type: "img", location: "./assets/ParkingLot.png" },
    { id: "selfCheckout", type: "img", location: "./assets/SelfCheckout.png" },
    { id: "shoppingCart", type: "img", location: "./assets/ShoppingCart.png" },
    { id: "deliveryImage", type: "img", location: "./assets/DeliveryArea.png" },
    { id: "walls", type: "img", location: "./assets/Walls.png" },
    { id: "corners", type: "img", location: "./assets/Corners.png" },
    { id: "vehicles", type: "img", location: "./assets/VehicleSpritesheet.png" },
    { id: "interact", type: "img", location: "./assets/InteractIcon.png" }
];
/** Assets for items */
export const itemAssets = [
    //{ id: "items2", type: "img", location: "./assets/AllItemsSpritesheet.png" }
    { id: "items2", type: "img", location: "./assets/AllItemsSpritesheet2.png" }
];
/** Sound effects for gameplay events */
export const soundEffects = [
    { id: "orderAppear", type: "audio", location: "./assets/Order.ogg" },
    { id: "itemPickup", type: "audio", location: "./assets/PickUp.ogg" },
    { id: "orderComplete", type: "audio", location: "./assets/Success.ogg" },
    { id: "orderWrong", type: "audio", location: "./assets/Wrong.ogg" },
    { id: "angry", type: "audio", location: "./assets/angry.ogg" },
    { id: "happy", type: "audio", location: "./assets/happy.ogg" },
    { id: "uiSound", type: "audio", location: "./assets/uiSound.ogg" }
];
export const uiAssets = [
    { id: "dialogueBox", type: "img", location: "./assets/dialogueBox.png" },
    { id: "dialogueBoxSmall", type: "img", location: "./assets/dialogueBoxSmall.png" }
];
